import { io } from "socket.io-client";
import { API_BASE } from "../components/config";

const storedToken = localStorage.getItem('token');

const socket = io(API_BASE, {
  autoConnect: Boolean(storedToken),
  auth: { token: storedToken }
});

socket.on("connect", () => {
  if (process.env.NODE_ENV !== 'production') {
    console.log('Socket connected:', socket.id);
  }
});

socket.on("disconnect", (reason) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log('Socket disconnected:', reason);
  }
});

socket.on('connect_error', error => {
  if (process.env.NODE_ENV !== 'production') {
    console.warn('Socket connection error:', error.message);
  }

  if (['Invalid token', 'No token'].includes(error.message)) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    socket.disconnect();

    if (window.location.pathname !== '/') {
      window.location.assign('/');
    }
  }
});

export function connectSocket(token = localStorage.getItem('token')) {
  if (!token) return;
  socket.auth = { token };
  if (!socket.connected) socket.connect();
}

export function disconnectSocket() {
  socket.disconnect();
}

export function createMonitorSocket() {
  return io(API_BASE, {
    auth: { monitor: true },
    reconnection: true
  });
}

export default socket;
